export const SETUP_INTERCOM = 'intercom/SETUP_INTERCOM';
export const BOOTSTRAP_INTERCOM = 'intercom/BOOTSTRAP_INTERCOM';
